import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { useCookie } from 'react-use';

import MainContext from 'context/main';
import Modal from 'components/shared/modal';
import sendGtagEvent from 'utils/send-gtag-event';
import Settings from './settings';

import styles from './cookie-banner.module.scss';

const cx = classNames.bind(styles);

const COOKIE_KEY = 'user-has-accepted-cookies';
const COOKIE_VALUE_TRUE = 'everything';
const COOKIE_VALUE_FALSE = 'non-essential';

const CookieBanner = ({ setIsCookieBannerVisible }) => {
  const [cookieValue, updateCookie] = useCookie(COOKIE_KEY);
  const [isOpen, setIsOpen] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleAcceptClick = ({ nonEssentialValue = true }) => {
    setIsOpen(false);
    setIsCookieBannerVisible(false);

    if (nonEssentialValue) {
      updateCookie(COOKIE_VALUE_TRUE);
    } else {
      updateCookie(COOKIE_VALUE_FALSE);
    }
  };

  useEffect(() => {
    if (!cookieValue) {
      setIsOpen(true);
      setIsCookieBannerVisible(true);
    }

    if (cookieValue === COOKIE_VALUE_TRUE) {
      sendGtagEvent('cookie-consent');
    }
  }, [cookieValue]);

  const {
    sharedBlocks: {
      cookieBanner: {
        acf: { text, button1Text, button2Text },
      },
    },
  } = useContext(MainContext);

  return (
    <>
      <div className={cx('wrapper', { visible: isOpen })}>
        <div className="container">
          <div className={cx('inner')}>
            <div className={cx('left')}>
              <p className={cx('text')}>{text}</p>
            </div>

            <div className={cx('right')}>
              <span
                className={cx('button')}
                onClick={handleOpenModal}
                onKeyPress={handleOpenModal}
                tabIndex="0"
                role="button"
              >
                {button1Text}
              </span>
              <span
                className={cx('button', 'button_color_accent-primary')}
                onClick={handleAcceptClick}
                onKeyPress={handleAcceptClick}
                tabIndex="0"
                role="button"
              >
                {button2Text}
              </span>
            </div>
          </div>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onCloseButtonClick={handleCloseModal}
        onRequestClose={handleCloseModal}
      >
        <Settings handleCloseModal={handleCloseModal} handleAcceptClick={handleAcceptClick} />
      </Modal>
    </>
  );
};

CookieBanner.propTypes = {
  setIsCookieBannerVisible: PropTypes.func.isRequired,
};

export default CookieBanner;
